export enum ResourceKeys{
  EditIconAriaLabel = "EditIconAriaLabel"
}